/** Progreso del bloque de recalibración (CalibrationProgress.swift / getCalibrationProgress_ de la web). */
export interface CalibrationProgress {
  totalNormals: number;
  base: number;
  target: number;
  completed: number;
  blockNumber: number;
}

export function calibrationProgress(totalNormals: number, base: number, target: number, blockNumber: number): CalibrationProgress {
  const t = Math.max(1, target);
  return { totalNormals, base, target: t, completed: Math.min(Math.max(0, totalNormals - base), t), blockNumber: Math.max(1, blockNumber) };
}

export const isReviewDue = (p: CalibrationProgress) => p.completed >= p.target;
export const remainingNormals = (p: CalibrationProgress) => Math.max(0, p.target - p.completed);
